export default __webpack_public_path__ + "static/wrench_b.4b2f32894992d131cfa795b3ed33a77c.svg";